<div class="p-6 pt-4">
    <h3 class="text-xl font-bold text-shs-white-1 flex items-center gap-2">Edit User</h3>
    <p class="text-xs text-font-secondary">Update the user information below.</p>
    <div class="grid grid-cols-2 gap-2 mt-4" [formGroup]="formGroup">
        <sag-ui-input label="GID" formControlName="gid" class="col-span-2"></sag-ui-input>
        <sag-ui-input label="First Name" formControlName="firstName"></sag-ui-input>
        <sag-ui-input label="Last Name" formControlName="lastName"></sag-ui-input>
        <sag-ui-input label="Email" formControlName="email" class="col-span-2"></sag-ui-input>
        <sag-ui-select [multiple]="true" label="Role" formControlName="roles" class="col-span-2">
            <sag-ui-option *ngFor="let role of roles | keyvalue" [value]="role.value">{{ role.value }}</sag-ui-option>
        </sag-ui-select>
    </div>
    <div class="flex justify-end items-center gap-2 mt-8">
        <sag-ui-button color="secondary" size="sm" (click)="onClose(false)">Cancel</sag-ui-button>
        <sag-ui-button size="sm" [disabled]="invalid" (click)="onClose(true)">Save Changes</sag-ui-button>
    </div>
</div>
